import React, { useEffect, useState } from 'react'
import { getpostalcodes, LogInSchoolID } from '../../JS/Common';
import Popup from '../../Components/Popup';
import { CheckValidation } from '../../Components/Validations';
import { ApiGetCall, ApiGetCallAuthKey, ApiPostCall } from '../../JS/Connector';
import AlertsComp from '../../Components/AlertsComp';

export default function BuildingAddressPopup(props) {
    const [allData, setAllData] = useState({
        StreetLine1: '',
        StreetLine2: '',
        City: '',
        State: '0',
        PostalCode: ''
    });
    const [AllState, setallstate] = useState([]);
    useEffect(() => {
        getpostalcodes(setallstate);
        async function getBuildingData() {
            await ApiGetCallAuthKey("/getBuildingDataById/" + props?.selectedBuildingAddress.id).then((result) => {
                if (result == undefined || result == "") {
                    alert("Something went wrong");
                } else {
                    const responseRs = JSON.parse(result);
                    var buildingData = responseRs?.msg;
                    setAllData({
                        StreetLine1: buildingData.street_line_1,
                        StreetLine2: buildingData.street_line_2,
                        City: buildingData.city,
                        State: buildingData.state,
                        PostalCode: buildingData.postal_code
                    });
                }
            });
        }
        getBuildingData();

    }, []);
    const modalbody = (
        <div className='row parent' id="buildingAddressPopup">
            <div className="col-xl-6 col-12">
                <div className='col-12 text-start px-1 pb-1 shipdevice-font-style'>Street Line 1<label className='redText'>*</label></div>
                <input type="text" autoComplete='off' required name='StreetLine1' className="form-control"
                    value={allData.StreetLine1} onChange={(e) => setAllData({ ...allData, StreetLine1: e.target.value })} />
                <span className="form-text invalid-feedback">
                    *required
                </span>
            </div>
            <div className="col-xl-6 col-12">
                <div className='col-12 text-start px-1 pb-1 shipdevice-font-style'>Street Line 2</div>
                <input type="text" autoComplete='off' name='StreetLine2' className="form-control"
                    value={allData.StreetLine2} onChange={(e) => setAllData({ ...allData, StreetLine2: e.target.value })} />
            </div>
            <div className="col-xl-6 col-12 pt-3">
                <div className='col-12 text-start px-1 pb-1 shipdevice-font-style'>City<label className='redText'>*</label></div>
                <input type="text" autoComplete='off' required name='City' className="form-control"
                    value={allData.City} onChange={(e) => setAllData({ ...allData, City: e.target.value })} />
                <span className="form-text invalid-feedback">
                    *required
                </span>
            </div>
            <div className="col-xl-6 col-12 pt-3">
                <div className='col-12 text-start px-1 pb-1 shipdevice-font-style'>State<label className='redText'>*</label></div>
                <select name='State' required onChange={(e) => setAllData({ ...allData, State: e.target.value })}>
                    <option value="0">Select</option>
                    {AllState.map((item, i) => {
                        return <option key={i} value={item.state_code} selected={allData.State == item.state_code}>{item.state_code}</option>
                    })}
                </select>
                <span className="form-text invalid-feedback">
                    *required
                </span>
            </div>
            <div className="col-xl-6 col-12 pt-3">
                <div className='col-12 text-start px-1 pb-1 shipdevice-font-style'>Postal Code<label className='redText'>*</label></div>
                <input type="number" autoComplete='off' required name='PostalCode' className="form-control"
                    value={allData.PostalCode} onChange={(e) => setAllData({ ...allData, PostalCode: e.target.value })} />
                <span className="form-text invalid-feedback">
                    *required
                </span>
            </div>
        </div>
    )
    const handleUpdateBuildingAddress = async () => {
        var isFormValid = CheckValidation({ formID: 'buildingAddressPopup' });
        if (!isFormValid) return;
        props.setLoading(true);
        var raw = JSON.stringify({
            school_id: LogInSchoolID,
            name: props?.selectedBuildingAddress.name,
            building_id: props?.selectedBuildingAddress.id || 0,
            buildingaddupdateflag: 2,
            phone_no: props?.selectedBuildingAddress.phone_no || null,
            streetline1: allData.StreetLine1 || null,
            streetline2: allData.StreetLine2 || null,
            city: allData.City || null,
            state: allData.State || null,
            postal_code: allData.PostalCode || null,
        });
        await ApiPostCall("/addUpdateBuildings", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                props.setLoading(false);
                if (result == "success") {
                    props.setNewAlerts(<AlertsComp show={true} variant="success" msg={"Building Address Updated Successfully."} />);
                    props.closePopup();
                    setTimeout(() => {
                        props.setNewAlerts(<AlertsComp show={false} />);
                        props.getSchoolProfileInfo();
                    }, 1500);
                }
                else {
                    props.setNewAlerts(<AlertsComp show={true} variant="danger" msg={result} />);
                }
            }
        });
    }
    return (
        <div>
            <Popup isshow={props.buildingAddressPopup} size={"md"} title={"Building Address"}
                closePopup={(e) => { props.closePopup() }}
                modalBody={modalbody} handleSave={handleUpdateBuildingAddress} visibleSaveBtn={true} btnText={"Update"} />

        </div>
    )
}
